import React from 'react';

/**
 * AppFormLabel
 *
 * Simple form field label atom. Follows RA2N Atom rules:
 * - Prefixed with "App"
 * - Forwards refs
 * - Pure UI, no business logic
 * - Accessible via optional htmlFor prop
 */
export interface AppFormLabelProps {
  label: React.ReactNode;
  required?: boolean;
  className?: string;
  htmlFor?: string;
}

const AppFormLabel = React.forwardRef<HTMLDivElement, AppFormLabelProps>(
  ({ label, required = false, className = '', htmlFor }, ref) => {
    const badge = required && (
      <span className="ml-auto px-1.5 py-0.5 text-xs bg-pink-500 text-white rounded whitespace-nowrap">
        必須
      </span>
    );

    const justifyClass = required ? 'justify-between' : '';

    return (
      <div
        ref={ref}
        className={`flex items-center gap-1 whitespace-nowrap min-h-[32px] ${justifyClass} ${className}`}
      >
        <label htmlFor={htmlFor} className="font-medium text-gray-700 cursor-text">
          {label}
        </label>
        {badge}
      </div>
    );
  }
);

AppFormLabel.displayName = 'AppFormLabel';

export default AppFormLabel;
